import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {ToggleMenu, ToggleNotifications} from './admin.actions';

export interface AdminStateModel {
    matDrawerOpened: boolean;
    notificationSideNav: boolean;
}

export const ADMIN_STATE_DEFAULT = {
    notificationSideNav: false,
    matDrawerOpened: true,
};

@State<AdminStateModel>({
    name: 'admin',
    defaults: ADMIN_STATE_DEFAULT,
})
@Injectable({providedIn: 'root'})
export class AdminState {
    @Selector() static matDrawerOpened(state: AdminStateModel) {
        return state.matDrawerOpened;
    }

    @Selector() static notifications(state: AdminStateModel) {
        return state.notificationSideNav;
    }

    @Action(ToggleMenu)
    toggleMenu({patchState, getState}: StateContext<AdminStateModel>) {
        const status = getState().matDrawerOpened;
        return patchState({matDrawerOpened: !status});
    }

    @Action(ToggleNotifications)
    toggleNotifications({patchState, getState}: StateContext<AdminStateModel>, {show}: ToggleNotifications) {
        let notificationSideNav = show;
        const status = getState().notificationSideNav;
        if (notificationSideNav === undefined) {
            notificationSideNav = !status;
        }
        return patchState({notificationSideNav});
    }
}
